module.exports = __webpack_public_path__ + "static/media/X - 18 1.9193e8f7.png";